import { makeStyles, Typography, Box } from "@material-ui/core";

export const OfferTag = ({ label, picto }) => {
  const classes = useStyle();

  return (
    <Box className={classes.offerContainer}>
      {label && <Typography className={classes.offerLabel}>{label}</Typography>}
      {picto}
    </Box>
  );
};

const useStyle = makeStyles((theme) => ({
  offerContainer: {
    display: "flex",
    position: "relative",
    zIndex: 1,
  },

  offerLabel: {
    color: theme.palette.secondary.main,
    fontWeight: 500,
    fontSize: 17,
    marginRight: theme.spacing(2),
  },
}));
